"use client";

import { c as _c } from "react/compiler-runtime";
import type { GetSectionType } from "page";
import Kicker from "app/components/Kicker";
import PrimaryCta from "app/components/PrimaryCta";
import { gsap, ScrollTrigger } from "gsap/all";
import { useLoadState } from "library/link/useLoadState";
import { type MarqueeLoop, Marquee } from "library/Marquee";
import { useAnimation } from "library/useAnimation";
import { useMedia } from "library/useMedia";
import { useRef, useState } from "react";
import { withComponent } from "library/styled/withComponent";
import { Wrapper, StickyFrame, Inner, ContentBox, TextFrame, LineSegment, StyledPrimaryCta as StyledPrimaryCta___raw, StyledMarquee as StyledMarquee___raw, Item, ItemText } from "data:text/javascript;base64,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";
gsap.registerPlugin(ScrollTrigger);
const clamp01 = (value: number) => Math.max(0, Math.min(1, value));
export default function InPracticeSection(t0) {
  const $ = _c(29);
  const {
    kicker,
    link,
    practices,
    headerMode
  } = t0;
  const {
    completed: preloaderDone
  } = useLoadState();
  const isMobile = useMedia(false, false, true, true);
  const FADE_DISTANCE = isMobile ? 80 : 240;
  const wrapperRef = useRef(null);
  const contentRef = useRef(null);
  const textFrameRef = useRef(null);
  const leftLineRef = useRef(null);
  const rightLineRef = useRef(null);
  const marqueeRef = useRef(null);
  const inViewRef = useRef(false);
  const progressRef = useRef(0);
  const [loopVersion, setLoopVersion] = useState(0);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => setLoopVersion(_temp);
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const handleLoopChange = t1;
  let t2;
  let t3;
  let t4;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      const el = wrapperRef.current;
      if (!el) {
        return;
      }
      const st = ScrollTrigger.create({
        trigger: el,
        start: "bottom 60%",
        end: "bottom top",
        onUpdate: self => {
          progressRef.current = self.progress;
        }
      });
      const inViewST = ScrollTrigger.create({
        trigger: el,
        start: "top bottom+=100px",
        end: "bottom top-=100px",
        onToggle: self_0 => {
          inViewRef.current = self_0.isActive;
        }
      });
      inViewRef.current = inViewST.isActive;
      return () => {
        st.kill();
        inViewST.kill();
      };
    };
    t3 = [];
    t4 = {
      recreateOnResize: true,
      updateBehavior: "kill"
    };
    $[1] = t2;
    $[2] = t3;
    $[3] = t4;
  } else {
    t2 = $[1];
    t3 = $[2];
    t4 = $[3];
  }
  useAnimation(t2, t3, t4);
  let t5;
  if ($[4] !== FADE_DISTANCE || $[5] !== preloaderDone) {
    t5 = () => {
      const content = contentRef.current;
      const textFrame = textFrameRef.current;
      const left = leftLineRef.current;
      const right = rightLineRef.current;
      const marquee = marqueeRef.current;
      if (!content || !textFrame || !left || !right || !marquee || !preloaderDone) {
        return;
      }
      let lastSegment = -1;
      const ease = gsap.parseEase("power2.inOut");
      const fadeEase = gsap.parseEase("power3.in");
      const track = content.querySelector(".track");
      let spanEls = [...content.querySelectorAll("[data-index]")];
      const spanObserver = new MutationObserver(() => {
        spanEls = [...content.querySelectorAll("[data-index]")];
      });
      spanObserver.observe(track ?? content, {
        childList: true
      });
      let cachedCount = 0;
      let cachedFade = FADE_DISTANCE;
      const update = () => {
        if (!inViewRef.current) {
          return;
        }
        const lineRect = left.getBoundingClientRect();
        const lineVisible = lineRect.height > 0;
        const lineY = lineVisible || !track ? lineRect.top : track.getBoundingClientRect().top + track.getBoundingClientRect().height / 2;
        let above = null;
        let below = null;
        const entries = spanEls.map(_temp2);
        if (entries.length !== cachedCount) {
          cachedCount = entries.length;
          cachedFade = FADE_DISTANCE;
          const centers = entries.map(_temp3).sort(_temp4);
          const gaps = [];
          for (let i = 1; i < centers.length; i++) {
            const cur = centers[i];
            const prev = centers[i - 1];
            if (cur !== undefined && prev !== undefined) {
              gaps.push(cur - prev);
            }
          }
          if (gaps.length) {
            gaps.sort(_temp5);
            const spacing = gaps[Math.floor(gaps.length / 2)];
            if (spacing && spacing > 0) {
              cachedFade = spacing * 1.5;
            }
          }
        }
        const fadeDistance = cachedFade;
        for (const {
          span: span_0,
          center,
          width
        } of entries) {
          const d = center - lineY;
          if (d <= 0) {
            if (!above || d > above.d) {
              above = {
                d,
                width
              };
            }
          } else {
            if (!below || d < below.d) {
              below = {
                d,
                width
              };
            }
          }
          const closeness = clamp01(1 - Math.abs(d) / fadeDistance);
          span_0.style.opacity = `${0.05 + 0.95 * fadeEase(closeness)}`;
        }
        if (!lineVisible) {
          return;
        }
        let gap;
        if (above && below) {
          const t = -above.d / (below.d - above.d);
          gap = above.width + (below.width - above.width) * ease(t);
        } else {
          gap = (above ?? below)?.width ?? 0;
        }
        gap = gap + 16;
        const seg = Math.max(0, textFrame.clientWidth / 2 - gap / 2);
        if (Math.abs(seg - lastSegment) > 0.5) {
          left.style.width = `${seg}px`;
          right.style.width = `${seg}px`;
          lastSegment = seg;
        }
      };
      const SNAP = {
        duration: 1,
        dwell: 0.75
      };
      let stopped = false;
      let mode = null;
      let wait;
      let moveTween;
      const step = () => {
        if (stopped || mode !== "snap") {
          return;
        }
        moveTween = marquee.next({
          duration: SNAP.duration,
          ease: "power4.inOut",
          onComplete: () => {
            if (stopped || mode !== "snap") {
              return;
            }
            wait = gsap.delayedCall(SNAP.dwell, step);
          }
        });
      };
      const enterSnap = () => {
        if (mode === "snap") {
          return;
        }
        mode = "snap";
        marquee.pause();
        marquee.timeScale(1);
        marquee.closestIndex(true);
        const landing = marquee.current() + 2;
        moveTween = marquee.toIndex(landing, {
          duration: 0.9,
          ease: "power3.out",
          onComplete: () => {
            if (stopped || mode !== "snap") {
              return;
            }
            wait = gsap.delayedCall(SNAP.dwell, step);
          }
        });
      };
      const enterSpin = () => {
        if (mode === "spin") {
          return;
        }
        mode = "spin";
        wait?.kill();
        moveTween?.kill();
        marquee.play();
      };
      const enterIdle = () => {
        if (mode === "idle") {
          return;
        }
        mode = "idle";
        wait?.kill();
        moveTween?.kill();
        marquee.pause();
      };
      const spinScale = _temp6;
      const drive = () => {
        if (stopped) {
          return;
        }
        if (!inViewRef.current) {
          enterIdle();
          return;
        }
        const p_0 = progressRef.current;
        if (p_0 > 0) {
          enterSpin();
          marquee.timeScale(spinScale(p_0));
        } else {
          enterSnap();
        }
      };
      gsap.ticker.add(update);
      gsap.ticker.add(drive);
      return () => {
        stopped = true;
        wait?.kill();
        moveTween?.kill();
        spanObserver.disconnect();
        gsap.ticker.remove(update);
        gsap.ticker.remove(drive);
        marquee.pause();
        marquee.timeScale(1);
        left.style.width = "";
        right.style.width = "";
        for (const span_1 of spanEls) {
          span_1.style.opacity = "";
        }
      };
    };
    $[4] = FADE_DISTANCE;
    $[5] = preloaderDone;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== loopVersion || $[8] !== practices || $[9] !== preloaderDone) {
    t6 = [practices, preloaderDone, loopVersion];
    $[7] = loopVersion;
    $[8] = practices;
    $[9] = preloaderDone;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = {
      recreateOnResize: true,
      updateBehavior: "kill"
    };
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  useAnimation(t5, t6, t7);
  let t8;
  if ($[12] !== practices) {
    t8 = practices && <StyledMarquee mode="vertical" marqueeSpeed={0} disableDrag={true} loopRef={marqueeRef} onLoopChange={handleLoopChange}>{practices.map(_temp7)}</StyledMarquee>;
    $[12] = practices;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t10;
  let t9;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <LineSegment data-side="left" ref={leftLineRef} />;
    t10 = <LineSegment data-side="right" ref={rightLineRef} />;
    $[14] = t10;
    $[15] = t9;
  } else {
    t10 = $[14];
    t9 = $[15];
  }
  const t11 = kicker || "In Practice";
  let t12;
  if ($[16] !== t11) {
    t12 = <Kicker>{t11}</Kicker>;
    $[16] = t11;
    $[17] = t12;
  } else {
    t12 = $[17];
  }
  let t13;
  if ($[18] !== link) {
    t13 = link && <StyledPrimaryCta href={link}>{link.text}</StyledPrimaryCta>;
    $[18] = link;
    $[19] = t13;
  } else {
    t13 = $[19];
  }
  let t14;
  if ($[20] !== t12 || $[21] !== t13) {
    t14 = <TextFrame ref={textFrameRef}>{t9}{t10}{t12}{t13}</TextFrame>;
    $[20] = t12;
    $[21] = t13;
    $[22] = t14;
  } else {
    t14 = $[22];
  }
  let t15;
  if ($[23] !== t14 || $[24] !== t8) {
    t15 = <StickyFrame><Inner><ContentBox ref={contentRef}>{t8}{t14}</ContentBox></Inner></StickyFrame>;
    $[23] = t14;
    $[24] = t8;
    $[25] = t15;
  } else {
    t15 = $[25];
  }
  let t16;
  if ($[26] !== headerMode || $[27] !== t15) {
    t16 = <Wrapper ref={wrapperRef} data-header-mode={headerMode}>{t15}</Wrapper>;
    $[26] = headerMode;
    $[27] = t15;
    $[28] = t16;
  } else {
    t16 = $[28];
  }
  return t16;
}
function _temp7(item, index) {
  return <Item key={item}><ItemText data-index={index}>{item}</ItemText></Item>;
}
function _temp6(p) {
  return 1 + 2 * clamp01(p);
}
function _temp5(a_0, b_0) {
  return a_0 - b_0;
}
function _temp4(a, b) {
  return a - b;
}
function _temp3(e) {
  return e.center;
}
function _temp2(span) {
  const rect = span.getBoundingClientRect();
  return {
    span,
    center: rect.top + rect.height / 2,
    width: rect.width
  };
}
function _temp(v) {
  return v + 1;
}
const StyledPrimaryCta = withComponent(PrimaryCta, StyledPrimaryCta___raw);
const StyledMarquee = withComponent(Marquee, StyledMarquee___raw);